module.exports = __webpack_public_path__ + "img/mobile-check-secondary.938c13f5.png";